const host = "https://www.cdt.cc/xlweb/public";
// const host = "http://61.141.235.103/xlweb/public";

export { host }